(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-soccer/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/themes/sport-soccer/assets/javascripts/init.js'); var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_soccer = svs.themes.sport_soccer || {};

  svs.themes.sport_soccer.init = function(func, params) {
    var log = new svs.core.log.Logger('svs.themes.sport_soccer.init');

    if (!_.isArray(params)) {
      params = [params];
    }

    if (typeof svs.themes.sport_soccer[func] === 'function') {
      return svs.themes.sport_soccer[func].apply(
        svs.themes.sport_soccer,
        params
      );
    }
    log.debug('function ' + func + ' does not exist in this theme');
  };
})(svs);

 })(window);